import { useState } from 'react';
import { Row, Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { languageList } from '../../../_services/common.service';
import { useLanguageSelect } from '../../../utils/languageUtils';

import LogoUrl from '../../../assets/images/cloud-logo.png';
import './style.scss';

const TopNavBar = () => {
  const navigate = useNavigate();
  return (
    <Row>
      <div className="top-nav-bar">
        <div className={`top-nav-bar-image rtl`}>
          <img
            alt="Arigo Logo"
            src={LogoUrl}
            height="50"
            className="image"
            onClick={() => navigate('/')}
          />
        </div>
        {/* <div className="top-nav-bar-button">
          <Button
            style={{ width: 130 }}
            type="primary"
            onClick={() => navigate('/login')}
          >
            Login
          </Button>
        </div> */}
      </div>
    </Row>
  );
};

export default TopNavBar;
